import type { schemaType } from '~~/modules/api/strapi/vacaciones-landings/detail/schema'
import type { propsInterface } from '~~/modules/design-system/sections/s-long-description.vue'

export const useToSLongDescription = () => {
  const fromStrapiHolidaysDetail = (
    data: schemaType,
  ): propsInterface['text'] => {
    const longDescription = data.attributes.long_description?.text

    return longDescription
  }
  return { fromStrapiHolidaysDetail }
}
